<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="col-12">
      <legend class="usa-legend usa-legend--large">HHG Scope Report</legend>
    </div>
  </div>
  <form [formGroup]="hhgScopeReportForm">
    @if (showIntlMsg) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--info usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text define-text-secondary">
              Note: If "All SCACs" and a "Scope Type" of "International" is selected, you may not select both "All Origins" and "All Destinations.
            </p>
          </div>
        </div>
      </div>
    }

    @if (showIntraMsg) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--info usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text define-text-secondary">
              Note:For intrastate Alaska scope reports, "Interstate" must be chosen as the "Scope Type."
            </p>
          </div>
        </div>
      </div>
    }

    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="scopeTypeSelect" class="usa-label">Scope Type<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="scopeTypeSelect" class="maxw-full usa-select" formControlName='scopeTypeSelect' (change)="scopeTypeChange($event.target.value)" required>
          <option hidden value='' selected disabled>Choose...</option>
          @for (scopeTypeSingle of scopeTypeList; track scopeTypeSingle) {
            <option [value]="scopeTypeSingle.value">
            {{scopeTypeSingle.name}}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="origin" class="usa-label">Origin</label>
        <select id="origin" class="usa-select maxw-full" formControlName='origin' (change)="originChange($event.target.value)">
          <option value='-2' selected disabled>Choose...</option>
          <option value='-1'>All Origins</option>
          @for (origin of origin$|async; track origin) {
            <option [value]="origin.stateCountryId">
            {{origin.stateCountryCode}} - {{origin.stateCountryName }}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="destination" class="usa-label">Destination</label>
        <select id="destination" class="usa-select maxw-full" formControlName='destination'
          (change)="destinationChange($event.target.value)">
          <option  value='-2' selected disabled>Choose...</option>
          <option  value='-1'>All Destinations</option>
          @for (destination of destination$|async; track destination) {
            <option
              [value]="destination.stateCountryId">
            {{destination.stateCountryCode}} - {{destination.stateCountryName }}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="scac" class="usa-label">SCAC<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
        <select multiple id="scac" class="usa-select maxw-full define-height-usa-select" formControlName="scac" size="10" (change)="scacChange($event.target.value)" required>
          <option value='' selected disabled>Choose...</option>
          <option value='-1'>All SCACs</option>
          @for (carrier of carrierList; track carrier) {
            <option [value]="carrier.carrierId">
              {{carrier.scac}} - {{carrier.scacName}}
            </option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-2">
        <button type="button" class="usa-button" [disabled]="disableBtn" (click)='download()'>Download</button>
        <button type="button" class="usa-button" [disabled]="disableBtn" (click)='searchReports()'>Search</button>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-4" >
        <span>
          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
            <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
          </svg>
          Right click on the report and select the appropriate options to export.
        </span>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <ag-grid-angular class="ag-theme-alpine"
          [gridOptions]="hhgScopeResultsGridOptions"
          [rowData]="hhgScopeReportList"
          [columnDefs]="columnDefs"
          [overlayNoRowsTemplate]="overlayNoRowsTemplate"
          [suppressDragLeaveHidesColumns]="true"
          ag-grid-resize>
        </ag-grid-angular>
      </div>
    </div>
  </form>
</div>